import { render } from "./Favicon.vue?vue&type=template&id=d3f63edc&scoped=true"
import script from "./Favicon.vue?vue&type=script&lang=js"
export * from "./Favicon.vue?vue&type=script&lang=js"

import "./Favicon.vue?vue&type=style&index=0&id=d3f63edc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src198257980/src/impact-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3f63edc"]])

export default __exports__